import { getRetailerState } from "./selectors";
import { CUSTOMER_TYPE, CustomerType } from "../../../../../constants";
import { RootState } from "../../../../../models";
import { PhoneNumbersState } from "../../../../../models/state";

export type State = RootState;
export const getPhoneNumbers: (state: State) => Partial<PhoneNumbersState> = (state) =>
    getRetailerState(state).phoneNumbers || {};
export const getSelectedPanel: (state: State) => CustomerType = (state) =>
    getPhoneNumbers(state).selectedPanel || CUSTOMER_TYPE.PORT_IN;

export const getAvailablePhoneNumbers: (state: State) => string[] = (state) => getPhoneNumbers(state).available || [];
export const getCurrentPhoneNumberCheckMessages = (state: State, subscriptionId?: string) => {
    const messages = getPhoneNumbers(state).messages || [];
    if (subscriptionId) {
        return messages.filter((message) => message.subscriptionId === subscriptionId);
    }
    return messages;
};

export const getAvailablePricePlans = (state: State, subscriptionId?: string): string[] => {
    const allPricePlans = getPhoneNumbers(state).availablePricePlans || {};
    if (!subscriptionId) return [];
    return allPricePlans[subscriptionId] || [];
};

export const getAvailableIcims = (state: State, subscriptionId?: string): Record<string, string[]> => {
    const allIcims = getPhoneNumbers(state).availableIcims || {};
    if (!subscriptionId) return {};
    return allIcims[subscriptionId] || {};
};

export const getBreakageFeeAmount = (state: State, subscriptionId?: string): number | undefined => {
    if (!subscriptionId) return undefined;
    return (getPhoneNumbers(state).breakageFeeAmounts || {})[subscriptionId];
};

export const getCanKeepCurrentPricePlan = (state: State, subscriptionId?: string): boolean => {
    if (!subscriptionId) return false;
    return !!(getPhoneNumbers(state).canKeepCurrentPricePlan || {})[subscriptionId];
};

export const getOfferingsCreditRequirements = (state: State, subscriptionId?: string): Record<string, boolean> => {
    const allRequirements = getPhoneNumbers(state).offeringsCreditRequirements || {};
    if (!subscriptionId) return {};
    return allRequirements[subscriptionId] || {};
};
